DOMReady( function(){
  /* ========================================================================
   * sharelink
   * ======================================================================== */
  [... document.querySelectorAll('.sharelink')].map( sharelinkbtn => {
    sharelinkbtn.addEventListener('click', function(e){
      e.preventDefault();
      let contenturl = sharelinkbtn.dataset.url;
      if( contenturl ){
        let input = document.body.appendChild( document.createElement("input") );
        input.value = contenturl;
        input.focus();
        input.select();
        document.execCommand('copy');
        input.parentNode.removeChild(input);
      }
      return false;
    });
  });
});
